module.exports = __webpack_public_path__ + "static/media/S (147).08b7db68.jpg";